/*!
 * Interview Questions - Version: 2.8.19
 * Indeed - Copyright (c) 2024
 * This file is generated automatically. Do not edit.
 *
 * Contains sources adapted from Twitter Bootstrap v4.0.0-alpha.3, which are
 * licensed under MIT (https:
 */

(function ($) {

    $(document).ready(function () {
        var toggleSwitch = false;
        var toogleDelay = 0;

        $( ".has-dropdown > a" )
            .click(function(event){
            });
        $( ".has-dropdown" ).hover(function() {
            var that = this;
            toggleSwitch = !toggleSwitch;

            if (toggleSwitch) {
                $(that).find('> .menu-dropdown').fadeIn();
                $(that).addClass('dropdown-active');
            } else {
                $(that).find('> .menu-dropdown').fadeOut();
                $(that).removeClass('dropdown-active');
            }
        });
        $( ".show-more-questions-text" )
            .on('click', function(event) {
                event.preventDefault();
                $( ".extra-question, .show-more-questions-text" ).toggleClass('text-hidden');
                if ($(this).hasClass('show-more-text')) {
                    $( ".extra-question" ).first().find('a').focus();
                } else if ( $(this).hasClass('show-fewer-text') ) {
                    $(".show-more-text").focus();
                }
            });

        if (!$('.opt-floating-steps').length) {
            return;
        }
        $('.opt-floating-steps').slick({
            accessibility: false,
            slidesToShow: 3,
            infinite: false,
            dots: false,
            arrows: false,
            centerPadding: '10px',
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        accessibility: true,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: false,
                        dots: true,
                        arrows: true,
                        prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" aria-disabled="false"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">' +
                            '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M14.112 18.002c.2.2.52.204.716.008l.707-.707a.507.507 0 00-.009-.716L10.94 12l4.587-4.587c.2-.2.205-.521.01-.716l-.708-.708a.507.507 0 00-.716.01l-5.648 5.647c-.1.1-.148.234-.143.367.002.124.05.247.143.34l.001.001a.758.758 0 00.008.008l5.64 5.64z"/></svg>' +
                            '</button>',
                        nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" aria-disabled="false">' +
                            '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M9.888 5.998a.506.506 0 00-.716-.008l-.707.707a.506.506 0 00.01.716L13.06 12l-4.587 4.587c-.2.2-.204.521-.009.716l.707.707a.507.507 0 00.717-.009l5.647-5.648c.1-.1.148-.233.144-.366a.492.492 0 00-.144-.34v-.001a.611.611 0 00-.009-.009L9.888 5.998z"/></svg>' +
                            '</button>'
                    }
                }
            ]
        });
        $('.opt-handle, .opt-floating-head').on('click', function(event){
            $('.opt-floating-cta').toggleClass('opt-slide-left');
            $('.opt-floating-head').focus();
        });
    });
})(jQuery);
function getCookie(name) {
    const nameWithSeparator = name + "=";
    const cookies = document.cookie.split(";");

    for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i].trim();

        if (cookie.indexOf(nameWithSeparator) === 0) {
            return cookie.substring(nameWithSeparator.length, cookie.length);
        }
    }

    return null;
}
function getGnavConfig() {
    const gnavConfigElement = document.getElementById("_indeed_gnav_config");

    if (gnavConfigElement !== null) {
        const gnavConfig = JSON.parse(gnavConfigElement.textContent);
        return gnavConfig;
    }

    return null;
}
function isUserLoggedIn() {
    const gnavConfig = getGnavConfig();

    if (gnavConfig !== null && gnavConfig.hasOwnProperty("isLoggedIn")) {
        return gnavConfig.isLoggedIn;
    }

    return getCookie("SHOE") !== null || getCookie("SOCK") !== null;
}
function isReturningUser() {
    return getCookie("ADV") === "1";
}
function isNewUser() {
    return !(isUserLoggedIn() || isReturningUser());
}
function getLocale() {
    const gnavConfig = getGnavConfig();

    if (gnavConfig !== null && gnavConfig.hasOwnProperty("language")) {
        return { hl: gnavConfig.language, co: gnavConfig.country || "US" };
    }
    const pageWrapElement = document.getElementById("pageWrap");
    if (pageWrapElement && pageWrapElement.className.trim() !== "") {
        const locale = pageWrapElement.className.split(" ")[0]; 
        const twoOrFourLetterLocaleRegex = /^(([a-zA-Z]{2}_[a-zA-Z]{2})|[a-zA-Z]{2})$/;

        if (twoOrFourLetterLocaleRegex.test(locale)) {
            const hl = locale.split("_")[0];
            const co = locale.split("_")[1] || "US";

            return { hl: hl, co: co };
        }
    }

    return { hl: "en", co: "US" };
}
function isProductionEnvironment() {
    const gnavConfig = getGnavConfig();

    if (gnavConfig !== null) {
        return !gnavConfig.isPreproduction;
    }

    const host = window.location.hostname;

    return !host.includes(".qa.indeed.net");
}
function setupModalCloseListeners() {
    const nopassModalWrapper = document.getElementById("nopass-modal-wrapper");

    [].forEach.call(nopassModalWrapper.querySelectorAll(".nopass-close-button, .nopass-modal-overlay"), function (el) {
        el.addEventListener("click", function () {
            nopassModalWrapper.classList.add("hide-nopass");

            const companyName = document.getElementById("companyname");
            companyName.value = "";
            companyName.parentElement.classList.remove("nopass-text-input-wrapper--has-error");

            const email = document.getElementById("email");
            email.value = "";
            email.parentElement.classList.remove("nopass-text-input-wrapper--has-error");
            document.getElementById("label-no-companyname-error") && document.getElementById("label-no-companyname-error").classList.add("hide-nopass");
            document.getElementById("label-no-email-error") && document.getElementById("label-no-email-error").classList.add("hide-nopass");
            document.getElementById("label-invalid-email-error") && document.getElementById("label-invalid-email-error").classList.add("hide-nopass");

            clearAutocomplete();
        });
    });
}
function setupModalFocusTrap() {
    const nopassModalWrapper = document.getElementById("nopass-modal-wrapper");
    const focusableElements = nopassModalWrapper.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement = focusableElements[focusableElements.length - 1];

    nopassModalWrapper.addEventListener("keydown", function(e) {
        if (e.key === "Tab") {
            if (e.shiftKey) { 
                if (document.activeElement === firstFocusableElement) {
                    lastFocusableElement.focus();
                    e.preventDefault();
                }
            } else {
                if (document.activeElement === lastFocusableElement) {
                    firstFocusableElement.focus();
                    e.preventDefault();
                }
            }
        }
    });
}
function updateLocalesInLinksAndAttributes(hl, co) {
    const nopassModalWrapper = document.getElementById("nopass-modal-wrapper");
    [].forEach.call(nopassModalWrapper.querySelectorAll("#nopass-tos-link, #nopass-cookie-policy-link, #nopass-privacy-policy-link"), function (el) {
        el.href = el.href.replace("en", hl);
    });
    nopassModalWrapper.querySelector('[name="hl"]').value = hl;
    nopassModalWrapper.querySelector('[name="co"]').value = co;

    nopassModalWrapper.querySelector("#nopass-sign-in-link").href +=
        "?hl=" + hl +
        "&co=" + co +
        "&continue=" + encodeURIComponent(location.protocol + '//' + location.hostname + location.pathname);
}
function buildBaseContinueUrlWithTrackingParams(hrefComponents, hl, co) {
    const fromParam = hrefComponents.from !== null
        ? "&from=" + hrefComponents.from
        : "";
    const isidParam = hrefComponents.isid !== null
        ? "&isid=" + hrefComponents.isid
        : "";
    const ikwParam = hrefComponents.ikw !== null
        ? "&ikw=" + hrefComponents.ikw
        : "";

    const continueUrlWithTrackingParams = hrefComponents.baseContinueUrl +
        '?hl=' + hl +
        "&co=" + co +
        fromParam +
        isidParam +
        ikwParam +
        "&trafficTk=" + getCookie("CTK") +
        "&sid=" + location.hostname +
        "&kw=" + encodeURIComponent(location.pathname);

    return continueUrlWithTrackingParams;
}
function buildFinalContinueUrlWithCompanyNameParamIfNeeded(baseContinueUrlWithTrackingParams, companyName) {
    const url = new URL(baseContinueUrlWithTrackingParams);

    let prepopulateWithParam = "";
    if (["/o/p", "/p", "/p/post-job", "/j/post-job", "/build-jd"].some(ctaDestinationPath => url.pathname === ctaDestinationPath)) {
        prepopulateWithParam = "&prepopulateWith=" + encodeURIComponent('{"advertiserCompany":"' + companyName + '"}');
    }

    const finalContinueUrlWithQueryParams = baseContinueUrlWithTrackingParams +
        "&jstm=" + new Date().getTime().toString() +
        prepopulateWithParam;

    return finalContinueUrlWithQueryParams;
}
let autocompleteCore = null;
let currentSeqId = 0;
let lastSeenSeqId = 0;
function setupAutocompleteCore() {
    const locale = getLocale();
    const hl = locale.hl;
    const co = locale.co;
    const autocompleteEndpoint = isProductionEnvironment()
        ? "https://autocomplete.indeed.com/api/v0"
        : "https://autocomplete.sandbox.qa.indeed.net/api/v0";
    const config = {
        type: "company", 
        country: co, 
        language: hl, 
        count: 5, 
        enableEmptyQuery: true,
        page: "post-press", 
        useEachWord: true,
        showAlternateSuggestions: false,
        recentQueryCount: 2,
        recentQuery: [],
        dedupeRecentQueryResultsCaseInsensitively: false,
        userIdentifiers: { 
            ctk: getCookie("CTK")
        },
        submitOnSelected: false,
        debounce: true,
        debounceTimeoutInMs: 200,
        minimumQueryLength: 0,
        rich: false,
        endpoint: autocompleteEndpoint,
        prioritizeExactMatch: true,
    };
    autocompleteCore = new AutocompleteCore(config);
}
function getSuggestions(query, successCallback, errorCallback) {
    if (typeof autocompleteCore === 'undefined' || !autocompleteCore) {
        console.error('Autocomplete Core has not been initialized yet.');
        return;
    }

    currentSeqId = currentSeqId + 1;
    autocompleteCore.getSuggestions(
        query,
        currentSeqId,
        (seqId, suggestions, _) => { 
            if (seqId > lastSeenSeqId) {
                lastSeenSeqId = seqId;
                const companyNames = suggestions.map(suggestion => suggestion.suggestion);
                successCallback(companyNames);
            }
        },
        (seqId, error) => {
            if (seqId > lastSeenSeqId) {
                lastSeenSeqId = seqId;
                errorCallback(error);
            }
        }
    );
}
function clearAutocomplete() {
    const nopassModalWrapper = document.getElementById("nopass-modal-wrapper");
    const autoComplete = nopassModalWrapper.querySelector(".nopass-autocomplete");
    nopassModalWrapper.querySelector(".nopass-autocomplete-list") &&
    (autoComplete.classList.remove("is-open"),
        nopassModalWrapper.querySelectorAll(".nopass-autocomplete-list").forEach(el => el.remove()),
        nopassModalWrapper.querySelectorAll(".nopass-autocomplete-aria-results-available-wrapper").forEach(el => el.remove()));
    window.currentAutocompleteOptionIndex = -1;
}
function updateAutocompleteOptionIndexForKeyboardNavigation(companyNames, isDownKey) {
    const indexOffset = isDownKey
        ? 1
        : -1;
    if (window.currentAutocompleteOptionIndex + indexOffset >= companyNames.length) {
        window.currentAutocompleteOptionIndex = -1;
    } else if (window.currentAutocompleteOptionIndex + indexOffset < -1) {
        window.currentAutocompleteOptionIndex = companyNames.length - 1;
    } else {
        window.currentAutocompleteOptionIndex += indexOffset;
    }
}
function setupAutocompleteKeyboardNavigation() {
    const nopassModalWrapper = document.getElementById("nopass-modal-wrapper");
    const autoComplete = nopassModalWrapper.querySelector(".nopass-autocomplete");
    const companyName = nopassModalWrapper.querySelector("#companyname");

    companyName.addEventListener("keydown", function (e) {
        const isDownKey = e.key === "ArrowDown";
        const isUpKey = e.key === "ArrowUp";
        const isEnterKey = e.key === "Enter";
        const isEscapeKey = e.key === "Escape";
        const isTabKey = e.key === "Tab";

        const companyNames = nopassModalWrapper.querySelectorAll(".nopass-autocomplete-option"); 

        if (companyName.value && isEscapeKey) { 
            companyName.value = window.currentCompanyNameUserInput;
            clearAutocomplete();
            return;
        } else if (isEnterKey || isTabKey) { 
            const currentlySelectedAutocompleteOption = nopassModalWrapper.querySelector(".nopass-autocomplete-option.has-focus");

            if (currentlySelectedAutocompleteOption) {
                window.currentCompanyNameUserInput = currentlySelectedAutocompleteOption.textContent.trim();
            }

            clearAutocomplete();
            return;
        } else if (!autoComplete.classList.contains("is-open") && (isDownKey || isUpKey)) { 
            return;
        } else if ((!companyNames || !companyNames.length) || (!isUpKey && !isDownKey)) { 
            return;
        }

        e.preventDefault();

        updateAutocompleteOptionIndexForKeyboardNavigation(companyNames, isDownKey);

        [].forEach.call(nopassModalWrapper.querySelectorAll(".nopass-autocomplete-option.has-focus"), function (el) {
            el.classList.remove("has-focus");
        });

        if (window.currentAutocompleteOptionIndex === -1) {
            companyName.value = window.currentCompanyNameUserInput; 
        } else if (window.currentAutocompleteOptionIndex >= 0) {
            const currentlySelectedAutocompleteOption = nopassModalWrapper.querySelectorAll(".nopass-autocomplete-option")[window.currentAutocompleteOptionIndex];
            currentlySelectedAutocompleteOption.classList.add("has-focus");
            companyName.value = currentlySelectedAutocompleteOption.textContent.trim();
        }
    });
}
function setupAutocompleteOnChangeEventListeners() {
    const nopassModalWrapper = document.getElementById("nopass-modal-wrapper");
    const companyName = nopassModalWrapper.querySelector("#companyname");

    ["input", "paste"].forEach(function (event) {
        companyName.addEventListener(event, function () {
            clearAutocomplete();

            if (!companyName.value) {
                companyName.parentElement.classList.add("nopass-text-input-wrapper--has-error");
                document.getElementById("label-no-companyname-error") && document.getElementById("label-no-companyname-error").classList.remove("hide-nopass");
            } else {
                companyName.parentElement.classList.remove("nopass-text-input-wrapper--has-error");
                document.getElementById("label-no-companyname-error") && document.getElementById("label-no-companyname-error").classList.add("hide-nopass");

                window.currentCompanyNameUserInput = companyName.value;

                getSuggestions(
                    companyName.value,
                    (companyNames) => {
                        if (companyNames.length) {
                            const nopassModalWrapper = document.getElementById("nopass-modal-wrapper");
                            const companyName = nopassModalWrapper.querySelector("#companyname");
                            const autoComplete = nopassModalWrapper.querySelector(".nopass-autocomplete");
                            autoComplete.classList.add("is-open");

                            let list = '<ul class="nopass-autocomplete-list" role="listbox">';

                            companyNames.forEach(function (el) {
                                const item =
                                    '<li role="option" class="nopass-autocomplete-option">' +
                                    '  <span class="nopass-autocomplete-text">' +
                                    '    <span>' + el + '</span>' +
                                    '  </span>' +
                                    '</li>';
                                list += item;
                            });

                            list +=
                                '</ul>' +
                                '<div class="nopass-autocomplete-aria-results-available-wrapper">' +
                                '  <span aria-live="polite" aria-atomic="true" role="status" class="nopass-autocomplete-aria-results-available">' + companyNames.length + ' undefined</span>' +
                                '</div>';

                            autoComplete.insertAdjacentHTML("beforeend", list);

                            [].forEach.call(nopassModalWrapper.querySelectorAll(".nopass-autocomplete-option"), function (el) {
                                el.addEventListener("click", function () {
                                    companyName.value = el.textContent.trim();
                                    window.currentCompanyNameUserInput = companyName.value;
                                    clearAutocomplete();
                                });
                            });
                        }
                    },
                    (error) => {
                        console.error("Something went wrong while fetching company names for autocompletion: ", error);
                    }
                );
            }
        });
    });
}
function setupCompanyNameAutocomplete() {
    window.currentAutocompleteOptionIndex = -1; 
    window.currentCompanyNameUserInput = ""; 

    setupAutocompleteKeyboardNavigation();
    setupAutocompleteOnChangeEventListeners();
}
function setupEmailValidationListener() {
    const nopassModalWrapper = document.getElementById("nopass-modal-wrapper");
    const email = nopassModalWrapper.querySelector("#email");

    ["input", "paste"].forEach(function (event) {
        email.addEventListener(event, function () {
            document.getElementById("label-no-email-error") && document.getElementById("label-no-email-error").classList.add("hide-nopass");
            document.getElementById("label-invalid-email-error") && document.getElementById("label-invalid-email-error").classList.add("hide-nopass");

            if (!email.value) {
                email.parentElement.classList.add("nopass-text-input-wrapper--has-error");
                document.getElementById("label-no-email-error") && document.getElementById("label-no-email-error").classList.remove("hide-nopass");
            } else if (
                !/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/.test(
                    email.value
                )
            ) {
                email.parentElement.classList.add("nopass-text-input-wrapper--has-error");
                document.getElementById("label-invalid-email-error") && document.getElementById("label-invalid-email-error").classList.remove("hide-nopass");
            } else {
                email.parentElement.classList.remove("nopass-text-input-wrapper--has-error");
                document.getElementById("label-no-email-error") && document.getElementById("label-no-email-error").classList.add("hide-nopass");
                document.getElementById("label-invalid-email-error") && document.getElementById("label-invalid-email-error").classList.add("hide-nopass");
            }
        });
    });
}
function enableSubmitButtonIfInputsAreValid() {
    const nopassModalWrapper = document.getElementById("nopass-modal-wrapper");
    const inputs = nopassModalWrapper.querySelectorAll(".nopass-text-input-control");
    [].forEach.call(inputs, function (input) {
        ["input", "paste"].forEach(function (event) {
            input.addEventListener(event, function () {
                if (
                    [].every.call(inputs, function (el) {
                        return el.value;
                    }) &&
                    !nopassModalWrapper.querySelectorAll(".nopass-text-input-wrapper--has-error").length
                )
                    nopassModalWrapper.querySelector("#continueButton").removeAttribute("disabled");
                else {
                    nopassModalWrapper.querySelector("#continueButton").setAttribute("disabled", true);
                }
            });
        });
    });
}
function parseHref(href) {
    const url = new URL(href);
    const hostname = isProductionEnvironment()
        ? url.hostname
        : url.hostname.replace(".indeed.com", ".qa.indeed.net");

    const baseContinueUrl = url.protocol + "//" + hostname + url.pathname + url.hash; 
    const from = url.searchParams.get("from");
    const isid = url.searchParams.get("isid");
    const ikw = url.searchParams.get("ikw");

    return { baseContinueUrl: baseContinueUrl, from: from, isid: isid, ikw: ikw };
}
function setupBuildingFinalContinueUrlOnFormSubmit(cta, hl, co) {
    const href = cta.href
        || document.querySelector("." + cta.className.replaceAll(" ", ".") + ">a")
        || "https://employers.indeed.com/p/post-job";
    const hrefComponents = parseHref(href);

    const nopassModalWrapper = document.getElementById("nopass-modal-wrapper");
    nopassModalWrapper.querySelector(".account-creation").addEventListener("submit", function () {
        const companyName = nopassModalWrapper.querySelector("#companyname").value;
        const baseContinueUrlWithTrackingParams = buildBaseContinueUrlWithTrackingParams(hrefComponents, hl, co);
        const finalContinueUrl = buildFinalContinueUrlWithCompanyNameParamIfNeeded(baseContinueUrlWithTrackingParams, companyName);
        nopassModalWrapper.querySelector('[name="postJobURL"]').value = finalContinueUrl; 
    });
}
function setupNopassModalBehaviorIfNeeded() {
    if (!isNewUser() || document.getElementById("nopass-modal-wrapper") === null) {
        console.debug(`Skipping NoPass setup.
        --> User is logged in: ${isUserLoggedIn()}
        --> Returning user: ${isReturningUser()}
        --> New user: ${isNewUser()}
        --> Modal wrapper is null at time of Javascript running: ${document.getElementById("nopass-modal-wrapper") === null}
        --> Document at time of Javascript running: `, document
        );
        return;
    }

    setupModalCloseListeners();
    setupModalFocusTrap();

    const locale = getLocale();
    const hl = locale.hl;
    const co = locale.co;
    updateLocalesInLinksAndAttributes(hl, co);

    setupCompanyNameAutocomplete();
    setupEmailValidationListener();
    enableSubmitButtonIfInputsAreValid();
    const ctas = document.querySelectorAll(".smb-cta-btn.has-destination-url, .dm-offer-cta-btn.has-destination-url");
    ctas.forEach(cta => cta.addEventListener("click", function (e) {
        e.preventDefault();
        const nopassModalWrapper = document.getElementById("nopass-modal-wrapper");
        nopassModalWrapper.classList.remove("hide-nopass");
        const companyName = nopassModalWrapper.querySelector("#companyname");
        companyName.focus();
        setupBuildingFinalContinueUrlOnFormSubmit(cta, hl, co);
    }));
}

window.addEventListener('AutocompleteLoaded', setupAutocompleteCore);
window.addEventListener('load', setupNopassModalBehaviorIfNeeded);

if (typeof appendParamsOnce !== 'function') {
    window.appendParamsOnce = function (url, params) {
        const useParams = params.replace(/^(\?|\&)/, '');
        const anchorRegExp = new RegExp(/#.*$/);
        const urlAnchorMatch = url.match(anchorRegExp);

        const anchor = urlAnchorMatch == null ? '' : urlAnchorMatch;
        url = url.replace(anchorRegExp, '');

        if (url.match(new RegExp('[\\?|\\&]' + regExpEscape(useParams))) == null) {
            url += (url.indexOf('?') > 0 ? '&' : '?') + useParams;
        }
        url += anchor;

        return url;
    };
}

if (typeof regExpEscape !== 'function') {
    window.regExpEscape = function (s) {
        return String(s).replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, '\\\$1').replace(/\x08/g, '\\x08');
    };
}

const LinkingWidgetConstants = {
    TSV_DATA_SCHEMA_VERSION: 1,
    TSV_DATA_BASE_URL_DEV: "https://d3idcws7fdm94h.cloudfront.net/content-transfer/linking-widget",
    TSV_DATA_BASE_URL_QA: "https://d3v75sr4bu5gc4.cloudfront.net/content-transfer/linking-widget",
    TSV_DATA_BASE_URL_PROD: "https://d341ezm4iqaae0.cloudfront.net/content-transfer/linking-widget",
    TEMPLATE_TO_DISPLAYED_TEXT_MAPPING: {},
    RELATED_CONTENT_SLUG_TRANSLATION: {
        "de": {
            "interviewfragen": "interview-questions",
            "stellenbeschreibung": "job-description",
            "recruitingtipps": "how-to-hire"
        },
        "es": {
            "descripción-del-empleo": "job-description",
            "preguntas-entrevista": "interview-questions",
            "como-contratar": "how-to-hire"
        },
        "fr": {
            "questions-entretien-dembauche": "interview-questions",
            "description-du-poste": "job-description",
            "comment-recruter": "how-to-hire"
        },
        "fr_CA": {
            "questions-entrevue": "interview-questions",
            "comment-embaucher": "how-to-hire"
        },
        "it": {
            "descrizione-dell'-offerta": "job-description",
            "colloquio-domande": "interview-questions",
            "come-assumere": "how-to-hire"
        },
        "ja": {
            "求人票の書き方": "job-description"
        },
        "nl": {
            "sollicitatievragen": "interview-questions",
            "functiebeschrijving": "job-description",
            "recruitment-tips": "how-to-hire"
        },
        "pt": {
            "descrição-da-vaga": "job-description"
        },
        "sv": {
            "jobbeskrivning": "job-description"
        }
    },
    RELATED_CONTENT_DISPLAY_THRESHOLD_MIN: 2,
    RELATED_TITLES_DISPLAY_THRESHOLD_MIN: 2,
    RELATED_TITLES_DISPLAY_THRESHOLD_MAX: 5,
    RELATED_CONTENT: "related_content",
    RELATED_SLUGS: "related_slugs",
    RELATED_CONTENT_ISID: "related_scaled",
    RELATED_SLUGS_ISID: "related_titles",
    LINKING_WIDGET_STATE_UNINITIALIZED: "linking-widget-uninitialized",
    LINKING_WIDGET_STATE_ERROR: "linking-widget-error",
    LINKING_WIDGET_STATE_EMPTY: "linking-widget-empty",
    LINKING_WIDGET_STATE_CONTENT_COLUMN_ONLY: "linking-widget-content-column-only",
    LINKING_WIDGET_STATE_TITLE_COLUMN_ONLY: "linking-widget-title-column-only",
    LINKING_WIDGET_STATE_TITLE_TWO_COLUMNS: "linking-widget-two-columns"
};

class LinkingWidget {
    isSet(variable) {
        return !(typeof variable === 'undefined' || variable === null);
    }

    getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }

    getGnavConfig() {
        const gnavConfigElement = document.getElementById("_indeed_gnav_config");

        if (gnavConfigElement !== null) {
            const gnavConfig = JSON.parse(gnavConfigElement.textContent);
            return gnavConfig;
        }

        return null;
    }

     getLocale() {
        const gnavConfig = this.getGnavConfig();

        if (gnavConfig !== null && gnavConfig.hasOwnProperty("language")) {
            const hl = gnavConfig.language;
            const co = gnavConfig.country || "US";
            return `${hl}_${co}`;
        }
        const pageWrapElement = document.getElementById("pageWrap");
        if (pageWrapElement && pageWrapElement.className.trim() !== "") {
            const locale = pageWrapElement.className.split(" ")[0]; 
            const twoOrFourLetterLocaleRegex = /^(([a-zA-Z]{2}_[a-zA-Z]{2})|[a-zA-Z]{2})$/;

            if (twoOrFourLetterLocaleRegex.test(locale)) {
                const hl = locale.split("_")[0];
                const co = locale.split("_")[1] || "US";

                return `${hl}_${co}`;
            }
        }

        return "en_US";
     }

    getTranslatedContentTypes(contentType) {
        const locale = this.getLocale();
        const language = locale.split("_")[0];
        if (locale in LinkingWidgetConstants.RELATED_CONTENT_SLUG_TRANSLATION && contentType in LinkingWidgetConstants.RELATED_CONTENT_SLUG_TRANSLATION[locale]) {
            return LinkingWidgetConstants.RELATED_CONTENT_SLUG_TRANSLATION[locale][contentType];
        }
        else if (language in LinkingWidgetConstants.RELATED_CONTENT_SLUG_TRANSLATION && contentType in LinkingWidgetConstants.RELATED_CONTENT_SLUG_TRANSLATION[language]) {
            return LinkingWidgetConstants.RELATED_CONTENT_SLUG_TRANSLATION[language][contentType];
        } else {
            return contentType;
        }
    }
    getDisplayedTextForSlug(slug) {
        for (const data of this.linkingWidgetData) {
            if (data["slug"] === slug) {
                return data["title"];
            }
        }
        throw new Error("Unable to find displayed text for slug.");
    }
    getTitleForRelatedContentColumn(displayedTitle) {
         return displayedTitle;
    }
    getTitleForRelatedTitlesColumn() {
         if(LinkingWidgetConstants.TEMPLATE_TO_DISPLAYED_TEXT_MAPPING["RelatedJobTitles"]) {
             return LinkingWidgetConstants.TEMPLATE_TO_DISPLAYED_TEXT_MAPPING["RelatedJobTitles"];
         } else {
             throw new Error("Unable to find displayed text for related titles.");
         }
    }

    getCDNBaseUrl() {
        const hostname = window.location.hostname;
        if (hostname.includes(".wpengine.test")) {
            return LinkingWidgetConstants.TSV_DATA_BASE_URL_DEV;
        } else if (hostname.includes(".wpengine.com")) {
            return LinkingWidgetConstants.TSV_DATA_BASE_URL_QA;
        } else if (hostname.includes(".qa.indeed.net")) {
            return LinkingWidgetConstants.TSV_DATA_BASE_URL_QA;
        } else {
            return LinkingWidgetConstants.TSV_DATA_BASE_URL_PROD;
        }
    }
    getIkw() {
        if (this.isSet(subnavSearchSourceId)) {
            return subnavSearchSourceId.replace("subnav_search_", "");
        }
    }

    shouldInitializeLinkingWidget() {
        if (typeof TEMPLATE_TO_DISPLAYED_TEXT_MAPPING === 'undefined') {
            return false;
        }
        LinkingWidgetConstants.TEMPLATE_TO_DISPLAYED_TEXT_MAPPING = TEMPLATE_TO_DISPLAYED_TEXT_MAPPING;
        return true;
    }

    constructUrl(template, slug, isid, ikw) {
        const hire = window.location.pathname.split("/")[1];
        const query = new URLSearchParams();
        const cookieCO = this.getCookie("CO");
        if (this.isSet(cookieCO)) {
            query.append("co", cookieCO);
        }
        if (this.isSet(isid)) {
            query.append("isid", isid);
        }
        if (this.isSet(ikw)) {
            query.append("ikw", ikw);
        }
        if (this.isSet(query.toString())) {
            return `/${hire}/${template}/${slug}?${query.toString()}`;
        } else {
            return `/${hire}/${template}/${slug}`;
        }
    }

    fetchFile(url) {
        return fetch(url)
            .then((response) => {
                if (response.status === 200) {
                    const data = response.text();
                    return data;
                } else {
                    console.error("Unable to fetch linking widget data");
                }
            })
            .then(data => data)
            .catch(error => error);
    }

    initializeLinkingWidget(linkingWidgetData) {
        if (!this.isSet(linkingWidgetData)) {
            console.error("linkingWidgetData is not found");
            return;
        }
        const urlSegments = window.location.pathname.split("/").filter(element => element);
        const slug = urlSegments[urlSegments.length - 1];
        const currentContentType = urlSegments[urlSegments.length - 2];
        let shouldDisplayWidget = false;
        let relatedContent = [];
        let relatedTitles = [];
        let currentLinkingData;
        for (const data of linkingWidgetData) {
            if (data["slug"] === slug) {
                currentLinkingData = data;
                relatedContent = data[LinkingWidgetConstants.RELATED_CONTENT];
                relatedTitles = this.filterValidRelatedSlugsForCurrentContentType(data[LinkingWidgetConstants.RELATED_SLUGS], currentContentType);
                break;
            }
        }
        if (relatedContent.length >= LinkingWidgetConstants.RELATED_CONTENT_DISPLAY_THRESHOLD_MIN) {
            this.insertTitleForRelatedContentColumn(currentLinkingData);
            this.insertRelatedContent(currentLinkingData);
            const node = document.querySelector("#linking-widget-related-content");
            node.style.display = "flex";
            shouldDisplayWidget = true;
        }
        if (relatedTitles.length >= LinkingWidgetConstants.RELATED_TITLES_DISPLAY_THRESHOLD_MIN) {
            this.insertTitleForRelatedTitlesColumn(currentLinkingData);
            this.insertRelatedTitles(relatedTitles);
            const node = document.querySelector("#linking-widget-related-titles");
            node.style.display = "flex";
            shouldDisplayWidget = true;
        }
        if (shouldDisplayWidget) {
            const linkingWidgetNode = document.querySelector("#linking-widget");
            linkingWidgetNode.style.display = "flex";
        }
    }

    insertTitleForRelatedContentColumn(slugData) {
        const node = document.querySelector("#linking-widget-related-content .linking-widget-title");
        node.insertAdjacentHTML("afterbegin", `<h3> ${this.getTitleForRelatedContentColumn(slugData["title"])}</h3>`);
    }

    insertTitleForRelatedTitlesColumn() {
        const node = document.querySelector("#linking-widget-related-titles .linking-widget-title");
        node.insertAdjacentHTML("afterbegin", `<h3> ${this.getTitleForRelatedTitlesColumn()}</h3>`);
    }

    insertRelatedContent(slugData) {
        const urlSegments = window.location.pathname.split("/").filter(element => element);
        const currentContentType = urlSegments[urlSegments.length - 2];
        for (const contentType of slugData[LinkingWidgetConstants.RELATED_CONTENT]) {
            const node = document.querySelector("#linking-widget-related-content .linking-widget-links");
            const hrefUrl = this.constructUrl(contentType, slugData["slug"], LinkingWidgetConstants.RELATED_CONTENT_ISID, this.getIkw());
            const displayedText = LinkingWidgetConstants.TEMPLATE_TO_DISPLAYED_TEXT_MAPPING[this.getTranslatedContentTypes(contentType)];
            if (currentContentType === contentType) {
                node.insertAdjacentHTML("beforeend", `<li>${displayedText}</li>`);
            } else {
                node.insertAdjacentHTML("beforeend", `<li><a href="${hrefUrl}" data-tn-component="${LinkingWidgetConstants.RELATED_CONTENT_ISID}" data-tn-link="${this.getIkw()}" data-tn-element="linking-widget-link">${displayedText}</a></li>`);
            }
        }
    }

    insertRelatedTitles(relatedTitles) {
        const urlSegments = window.location.pathname.split("/").filter(element => element);
        const currentContentType = urlSegments[urlSegments.length - 2];
        for (const relatedTitle of relatedTitles) {
            const node = document.querySelector("#linking-widget-related-titles .linking-widget-links");
            const hrefUrl = this.constructUrl(currentContentType, relatedTitle, LinkingWidgetConstants.RELATED_SLUGS_ISID, this.getIkw());
            const displayedText = this.getDisplayedTextForSlug(relatedTitle);
            node.insertAdjacentHTML("beforeend", `<li><a href="${hrefUrl}" data-tn-component="${LinkingWidgetConstants.RELATED_SLUGS_ISID}" data-tn-link="${this.getIkw()}" data-tn-element="linking-widget-link">${displayedText}</a></li>`);
        }
    }
    filterValidRelatedSlugsForCurrentContentType(relatedSlugs, currentContentType) {
        const allSlugsForCurrentContentType = [];
        for (const linkingWidgetObject of this.linkingWidgetData) {
            const slug = linkingWidgetObject["slug"];
            const contentTypeArray = linkingWidgetObject[LinkingWidgetConstants.RELATED_CONTENT];
            if (contentTypeArray.includes(currentContentType)) {
                allSlugsForCurrentContentType.push(slug);
            }
        }

        const filteredRelatedSlugs = [];
        for (const relateSlug of relatedSlugs) {
            if (allSlugsForCurrentContentType.includes(relateSlug)) {
                filteredRelatedSlugs.push(relateSlug);
            }
        }

        return filteredRelatedSlugs.sort().slice(0, LinkingWidgetConstants.RELATED_TITLES_DISPLAY_THRESHOLD_MAX);
    }
    parseTSVToObject(tsvString) {
        const lines = tsvString.split(/\r\n|\r|\n/).filter(element => element);
        const result = [];
        const headers = lines.shift().split("\t");
        for (const line of lines) {
            const obj = {};
            const columns = line.split("\t");
            let validLine = true;
            for (let i = 0; i < headers.length; i++) {
                const header = headers[i];
                if (header === "slug" || header === "title") {
                    if (columns[i] === "") {
                        validLine = false;
                        continue;
                    }
                }
                if (header === "related_content" || header === "related_slugs") {
                    obj[header] = columns[i].replace(/\s/g, "").split(",").filter(element => element);
                } else {
                    obj[header] = columns[i];
                }
            }
            if (validLine) {
                result.push(obj);
            }
        }
        return result;
    }

    setLinkingWidgetTurnstileState(state) {
        const e = document.querySelector("#linking-widget");
        e.setAttribute("data-tn-element", state);
    }

    reportLinkingWidgetTurnstileState() {
        try {
            const e = document.querySelector("#linking-widget")?.getAttribute("data-tn-element");
            window.commonMetricsLibrary.report({"data-tn-element": e, "data-tn-action": "impression"});
        } finally {
            return;
        }
    }

    constructor() {
        if (!document.querySelector("#linking-widget")) {
            console.error("Linking widget element does not exist");
            try {
                window.commonMetricsLibrary.report({
                    "data-tn-element": LinkingWidgetConstants.LINKING_WIDGET_STATE_UNINITIALIZED,
                    "data-tn-action": "impression"
                });
            } finally {
                return;
            }
        }

        try {
            let hasError = false;
            this.setLinkingWidgetTurnstileState(LinkingWidgetConstants.LINKING_WIDGET_STATE_UNINITIALIZED);
            if (!this.shouldInitializeLinkingWidget()) {
                this.reportLinkingWidgetTurnstileState();
                return;
            }
            this.fetchFile(`${this.getCDNBaseUrl()}/${LinkingWidgetConstants.TSV_DATA_SCHEMA_VERSION}/${this.getLocale()}.tsv`)
                .then(tsvString => {
                    if (this.isSet(tsvString)) {
                        this.linkingWidgetData = this.parseTSVToObject(tsvString);
                        this.initializeLinkingWidget(this.linkingWidgetData);
                    }
                })
                .catch(error => {
                    this.setLinkingWidgetTurnstileState(LinkingWidgetConstants.LINKING_WIDGET_STATE_ERROR);
                    hasError = true;
                    console.error("Unable to initialize linking widget.", error);
                })
                .finally(() => {
                    if (hasError) {
                        this.reportLinkingWidgetTurnstileState();
                        return;
                    }
                    const contentColumnCount = document.querySelectorAll("#linking-widget-related-content h3").length;
                    const titleColumnCount = document.querySelectorAll("#linking-widget-related-titles h3").length;
                    if (contentColumnCount == 0 && titleColumnCount == 0) {
                        this.setLinkingWidgetTurnstileState(LinkingWidgetConstants.LINKING_WIDGET_STATE_EMPTY);
                    } else if (contentColumnCount == 1 && titleColumnCount == 1) {
                        this.setLinkingWidgetTurnstileState(LinkingWidgetConstants.LINKING_WIDGET_STATE_TITLE_TWO_COLUMNS);
                    } else if (contentColumnCount == 1) {
                        this.setLinkingWidgetTurnstileState(LinkingWidgetConstants.LINKING_WIDGET_STATE_CONTENT_COLUMN_ONLY);
                    } else if (titleColumnCount == 1) {
                        this.setLinkingWidgetTurnstileState(LinkingWidgetConstants.LINKING_WIDGET_STATE_TITLE_COLUMN_ONLY);
                    }
                    this.reportLinkingWidgetTurnstileState();
                });
        } catch(error) {
            console.error("Unable to initialize linking widget.", error);
            this.setLinkingWidgetTurnstileState(LinkingWidgetConstants.LINKING_WIDGET_STATE_ERROR);
            this.reportLinkingWidgetTurnstileState();
        }
    }
}

let linkingWidget;
window.addEventListener('DOMContentLoaded', () => linkingWidget = new LinkingWidget(), {once: true});
const EXIT_MODAL_DO_NOT_SHOW_SESSION_STORAGE_KEY = 'exit-modal-do-not-show';
const EXIT_MODAL_SHOW_ONCE_COOKIE_KEY = 'EXIT_MODAL_ALREADY_SHOWN';
const EXIT_MODAL_SHOW_ONCE_COOKIE_TTL = 300000; 
const MOBILE_INACTIVITY_POLLING_MS = 1000; 
const DESKTOP_DELAY_MS = 1000; 
function setExitModalShownCookie() {
    const now = new Date();
    const currentTime = now.getTime();
    now.setTime(currentTime + EXIT_MODAL_SHOW_ONCE_COOKIE_TTL);
    document.cookie = `${EXIT_MODAL_SHOW_ONCE_COOKIE_KEY}=true;expires=${now.toUTCString()};path=/`;
}

function deleteExitModalShownCookie() {
    document.cookie = `${EXIT_MODAL_SHOW_ONCE_COOKIE_KEY}=false;expires=${new Date(0).toUTCString()};path=/`;
}

function checkIfExitModalShownCookieExists() {
    return document.cookie.split(';')
        .some((cookie) => cookie.trim().startsWith(`${EXIT_MODAL_SHOW_ONCE_COOKIE_KEY}=`));
}
function calculateExitModalStatusForContentTemplates() {
    if (typeof exitModalQueryParameters !== 'undefined') {
        const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.keys(Object.fromEntries(urlSearchParams.entries()));
        const hasMatchingQueryParam = params.some(param => exitModalQueryParameters.has(param.toLowerCase()));

        if (hasMatchingQueryParam) {
            return true;
        }
    }

    return false;
}

function setupExitModal() {
    const exitModalWrapper = document.querySelector('.exit-modal-wrapper');
    document.body.insertBefore(exitModalWrapper, document.body.firstChild);

    setupExitModalFocusTrap();

    document.querySelector('.exit-modal-close').addEventListener('click', () => {
        deleteExitModalShownCookie();
        sessionStorage?.setItem(EXIT_MODAL_DO_NOT_SHOW_SESSION_STORAGE_KEY, 'true');
        document.querySelector('.exit-modal-wrapper').classList.add('hide-me');
    });
}

function displayExitModal() {
    setExitModalShownCookie();

    const exitModalWrapper = document.querySelector('.exit-modal-wrapper');
    exitModalWrapper.classList.remove('hide-me');
    exitModalWrapper.focus();
    try {
        if (window.commonMetricsLibrary) {
            window.commonMetricsLibrary.report({ 'data-tn-element': 'smb-exit-modal', 'data-tn-action': 'impression' });
        }
    } catch (error) {
        console.error('Failed to fire event for exit modal view: ', error);
    }
}
function setupExitModalFocusTrap() {
    const exitModalWrapper = document.querySelector('.exit-modal-wrapper');
    const focusableElements = exitModalWrapper.querySelectorAll("a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type='text']:not([disabled]), input[type='radio']:not([disabled]), input[type='checkbox']:not([disabled]), select:not([disabled])");
    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement = focusableElements[focusableElements.length - 1];

    exitModalWrapper.addEventListener('keydown', function(e) {
        if (e.key === 'Tab') {
            if (e.shiftKey) { 
                if (document.activeElement === firstFocusableElement) {
                    lastFocusableElement.focus();
                    e.preventDefault();
                }
            } else {
                if (document.activeElement === lastFocusableElement) {
                    firstFocusableElement.focus();
                    e.preventDefault();
                }
            }
        }
    });
}

window.addEventListener('DOMContentLoaded', () => {
    const exitModalWrapper = document.querySelector('.exit-modal-wrapper');
    if (!exitModalWrapper) {
        return;
    }

    if (isContentTemplate) {
        const shouldEnableExitModalForContentTemplates = calculateExitModalStatusForContentTemplates();

        if (!shouldEnableExitModalForContentTemplates) {
            console.debug('Disabling exit modal for Content template.');
            document.querySelector('.exit-modal-wrapper').remove();
            return;
        }
        console.debug('Leaving exit modal enabled for Content template based on existence of a query parameter.');
    }

    setupExitModal();
    if (
        ('userAgentData' in navigator && navigator.userAgentData.mobile) 
        || ('maxTouchPoints' in navigator && navigator.maxTouchPoints > 0) 
        || ('msMaxTouchPoints' in navigator && navigator.msMaxTouchPoints > 0) 
        || matchMedia?.('(pointer:coarse)') && matchMedia?.('(pointer:coarse)')?.media === '(pointer:coarse)' 
        || 'orientation' in window 
        || (/Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone|IEMobile|Opera Mini/i.test(navigator.userAgent)) 
    ) {
        let idleTimer = 0;
        ['touchstart', 'touchmove', 'click'].forEach((eventType) => document.addEventListener(eventType, () => idleTimer = 0));

        setInterval(() => {
            idleTimer++;

            if (idleTimer >= 10 
                && !sessionStorage?.getItem(EXIT_MODAL_DO_NOT_SHOW_SESSION_STORAGE_KEY) 
                && exitModalWrapper.classList.contains('hide-me')
            ) {
                displayExitModal();
            }
        }, MOBILE_INACTIVITY_POLLING_MS);
    } else {
        document.addEventListener('mouseout', (event) => {
            if (!event.toElement && !event.relatedTarget) {
                setTimeout(() => {
                    if (!checkIfExitModalShownCookieExists() 
                        && !sessionStorage?.getItem(EXIT_MODAL_DO_NOT_SHOW_SESSION_STORAGE_KEY) 
                        && exitModalWrapper.classList.contains('hide-me')
                    ) {
                        displayExitModal();
                    }
                }, DESKTOP_DELAY_MS);
            }
        });
    }
});

let initialColumnWidth;
function setRightRailStickyBehavior() {
    if (!document.querySelector('.right-rail')) {
        return;
    }
    const sidebarColumn = document.querySelector('.right-rail-full-column, .col-lg-4');
    if (!sidebarColumn) {
        return;
    }
    initialColumnWidth = Math.round(sidebarColumn.clientWidth);
    const bannerResizeObserver = new ResizeObserver((entries) => {
        entries.forEach((entry) => adjustRightRailParentHeight(entry.target));
    });
    const sidebarColumnsWithRightRail = Array.from(
        document.querySelectorAll('.right-rail-desktop'), 
        (rightRail) => rightRail.parentElement 
    );
    sidebarColumnsWithRightRail.forEach((column) => {
        bannerResizeObserver.observe(column); 
        column.classList.add('right-rail-full-column'); 
    });
    const contentSectionsWithRightRail = Array.from(document.querySelectorAll('.middle-rail-full-column, .col-lg-8'))
        .filter((contentSection) => contentSection.nextElementSibling !== null && contentSection.nextElementSibling.classList.contains('right-rail-full-column'));
    sidebarColumnsWithRightRail.forEach((column) => {
        window.addEventListener('scroll', () => {
            adjustRightRailParentHeight(column);
            const currentContentSection = [].find.call(contentSectionsWithRightRail, (contentSection) => isScrolledIntoView(contentSection)) || contentSectionsWithRightRail[contentSectionsWithRightRail.length - 1];
            if (currentContentSection) {
                const rightRailForCurrentSection = currentContentSection.nextElementSibling;
                if (rightRailForCurrentSection.style.display === 'none') rightRailForCurrentSection.style.display = '';
                contentSectionsWithRightRail.forEach((contentSection) => {
                    if (contentSection.nextElementSibling.isEqualNode(rightRailForCurrentSection) || contentSection.nextElementSibling.style.display === 'none') return;
                    contentSection.nextElementSibling.style.display = 'none';
                });
            }
        });
    });
}
function adjustRightRailParentHeight(sidebarColumn) {
    if (!sidebarColumn) {
        return;
    }
    if (sidebarColumn.textContent.trim().length <= 0) {
        return;
    }
    if (sidebarColumn.classList.contains('col-lg-3')) {
        return;
    }

    const columnWidth = Math.round(sidebarColumn.clientWidth);
    if (columnWidth <= 0) {
        return;
    }
    if (columnWidth <= initialColumnWidth && window.innerWidth <= 991) {
        sidebarColumn.classList.add('remove-dynamic-min-height-mobile');
        sidebarColumn.style.removeProperty('min-height');
    } else {
        sidebarColumn.classList.remove('remove-dynamic-min-height-mobile');
        const mainColumn = sidebarColumn.closest('.row').querySelector('.col-lg-8');
        if (mainColumn != null) {
            sidebarColumn.style.minHeight = mainColumn.clientHeight + 'px';
        }
    }
    initialColumnWidth = columnWidth;
}
function isScrolledIntoView(element) {
    if (!element) {
        return false;
    }
    const boundingClientRectangle = element.getBoundingClientRect();
    const subnavMenu = document.querySelector('.subnav-menu');
    const offset = subnavMenu
        ? subnavMenu.clientHeight
        : 0;
    const isVisible = boundingClientRectangle.bottom - offset >= 0;

    return isVisible;
}

function randomizeRightRailBannerVariant() {
    if (typeof RIGHT_RAIL_VARIANTS === 'undefined' || !RIGHT_RAIL_VARIANTS || RIGHT_RAIL_VARIANTS.length <= 1) {
        return;
    }

    const randomVariant = RIGHT_RAIL_VARIANTS[Math.floor(Math.random() * RIGHT_RAIL_VARIANTS.length)];
    const rightRailBanners = document.querySelectorAll('.right-rail-banner');
    rightRailBanners.forEach((rightRailBanner) => {
        const rightRailTitle = rightRailBanner.querySelector('.right-rail-title');
        if (rightRailTitle) {
            rightRailTitle.textContent = randomVariant['right_rail_title'];
        }

        const rightRailText = rightRailBanner.querySelector('.right-rail-text');
        if (rightRailText) {
            rightRailText.textContent = randomVariant['right_rail_copy'];
        }

        const rightRailCitation = rightRailBanner.querySelector('.right-rail-citation');
        if (rightRailCitation) {
            rightRailCitation.textContent = randomVariant['right_rail_citation'];
        }

        const rightRailCta = rightRailBanner.querySelector('.right-rail-btn');
        if (rightRailCta) {
            rightRailCta.textContent = randomVariant['right_rail_cta_text'];
            rightRailCta.href = randomVariant['right_rail_cta_link'];
        }

        if (randomVariant['right_rail_background_image']) {
            const backgroundImageUrl = randomVariant['right_rail_background_image']['url'];
            rightRailBanner.style.setProperty('background-image', `url(${backgroundImageUrl})`);
            rightRailBanner.style.setProperty('background-size', 'contain');
            rightRailBanner.classList.add('custom-background');
        } else {
            rightRailBanner.classList.remove('custom-background');
            rightRailBanner.style.removeProperty('background-image');
            rightRailBanner.style.removeProperty('background-size');
        }

        currentVariantId = `${TEMPLATE_SLUG}--${randomVariant["right_rail_variant_id"]}`;
    });
}

window.addEventListener('DOMContentLoaded', () => {
    randomizeRightRailBannerVariant();
    setRightRailStickyBehavior();
});
function expandTableOfContents(navLinks, tablesOfContents) {
    navLinks.forEach(function (navLink) {
        navLink.style.height = `${navLinks.scrollHeight}px`;
        navLink.style.maxHeight = 'fit-content'; 
        navLink.classList.add('expand-toc');
        navLink.setAttribute('aria-expanded', true);
    });

    tablesOfContents.forEach(function (tableOfContents) {
        tableOfContents.classList.add('expand-toc');
    });
    const desktopTableOfContents = document.querySelectorAll('.table-of-contents.toc-desktop');
    const desktopNavLinks = document.querySelectorAll('.table-of-contents.toc-desktop .nav-links-wrapper');
    const paddingOffset = 100;
    const fullNavHeight = desktopNavLinks[0].querySelector('li').offsetHeight * desktopNavLinks[0].querySelector('.nav-links').childElementCount + paddingOffset;
    if (window.innerWidth >= 992 && fullNavHeight > window.innerHeight) {
        desktopTableOfContents.forEach((toc) => {
            toc.style.top = '1rem';
            toc.querySelector('.toggle-toc-button').style.paddingBottom = '0';
        });
        desktopNavLinks.forEach((navLink) => {
            navLink.style.maxHeight = `${window.innerHeight - 50}px`; 
            navLink.style.overflowY = 'scroll';
        });
    } else {
        desktopTableOfContents.forEach((toc) => {
            toc.style.removeProperty('top');
            toc.querySelector('.toggle-toc-button').style.removeProperty('padding-bottom');
        });
    }
}
function collapseTableOfContents(navLinks, tablesOfContents) {
    navLinks.forEach(function (navLink) {
        navLink.style.maxHeight = '0px'; 
        navLink.classList.remove('expand-toc');
        navLink.setAttribute('aria-expanded', false);
    });

    tablesOfContents.forEach(function (tableOfContent) {
        tableOfContent.classList.remove('expand-toc');
        tableOfContent.style.removeProperty('top');
        tableOfContent.querySelector('.toggle-toc-button').style.removeProperty('padding-bottom');
    });
}
function toggleTableOfContents() {
    const navLinks = document.querySelectorAll('.table-of-contents .nav-links-wrapper');
    const tableOfContents = document.querySelectorAll('.table-of-contents');
    if (navLinks[0].style.maxHeight && navLinks[0].style.maxHeight !== '0px') {
        collapseTableOfContents(navLinks, tableOfContents);
    } else {
        expandTableOfContents(navLinks, tableOfContents);
    }
}
function addHeadingsToTableOfContents() {
    const tableOfContentNavLinks = document.querySelectorAll('.table-of-contents .nav-links');
    const articleContentH2HeadingsSelector = 'main .middle-rail-full-column h2';
    let headings = document.querySelectorAll(articleContentH2HeadingsSelector);
    if (headings.length < 4) {
        const articleContentH2andH3HeadingsSelector = 'main .middle-rail-full-column h2, main .middle-rail-full-column :not(.linking-widget-title) > h3';
        headings = document.querySelectorAll(articleContentH2andH3HeadingsSelector);
    }

    headings.forEach((heading, index) => {
        if (heading.innerText !== '') {
            const headingLevel = heading.nodeName === 'H2'
                ? 'main-heading'
                : 'sub-heading';
            const contentHTML = `<li class="${headingLevel}"><a href="#toc-jumpto-${index}">${heading.innerText}</a></li>`;
            heading.setAttribute('id', 'toc-jumpto-' + index);

            tableOfContentNavLinks.forEach(function (toc) {
                toc.insertAdjacentHTML('beforeend', contentHTML);
            });
        }
    });
}
function setupToggleClickHandlers() {
    document.querySelectorAll('.toggle-toc-button').forEach((toggle) => {
        if (toggle) {
            toggle.addEventListener('click', () => toggleTableOfContents());
        }
    });

    const navLinkWrappers = document.querySelectorAll('.nav-links-wrapper');
    document.querySelectorAll('.see-more-button').forEach((seeMoreButton) => {
        seeMoreButton.addEventListener('click', () => {
            navLinkWrappers.forEach((navLinkWrapper) => {
                navLinkWrapper.classList.add('show-more-links');
                navLinkWrapper.classList.remove('show-less-links');
            });
        });
    });
    document.querySelectorAll('.see-less-button').forEach((seeLessButton) => {
        seeLessButton.addEventListener('click', () => {
            navLinkWrappers.forEach((navLinkWrapper) => {
                navLinkWrapper.classList.add('show-less-links');
                navLinkWrapper.classList.remove('show-more-links');
            });
        });
    });
}
function setupAnchorScrollBehavior() {
    const navLinksItems = document.querySelectorAll(".nav-links a");

    navLinksItems.forEach((anchor) => {
        anchor.addEventListener('click', (e) => {
            e.preventDefault();

            for (const link of navLinksItems) {
                link.classList.remove('active');
            }

            document.querySelectorAll('a[href="' + anchor.getAttribute('href') + '"]')
                .forEach((navItem) => navItem.classList.add('active'));
            const topOfElement = document.querySelector(anchor.getAttribute('href')).getBoundingClientRect().top + window.scrollY - 150;
            window.scroll({ top: topOfElement, behavior: 'smooth' });
        });
    });
}
let _IsScrolledIntoView = typeof isScrolledIntoView != 'undefined' ? isScrolledIntoView :
    function (element) {
        if (!element) {
            return false;
        }
        const boundingClientRectangle = element.getBoundingClientRect();
        const subnavMenu = document.querySelector('.subnav-menu');
        const offset = subnavMenu ? subnavMenu.clientHeight : 0;
        const isVisible = boundingClientRectangle.bottom - offset >= 0;
        return isVisible;
    };


function setupTableOfContentsJumpBehavior() {
    const contentSectionsWithToC = Array.from(document.querySelectorAll('.middle-rail-full-column'))
        .filter((contentSection) => contentSection.previousElementSibling !== null && contentSection.previousElementSibling.classList.contains('left-rail-full-column'));
    contentSectionsWithToC.forEach((column) => {
        window.addEventListener('scroll', () => {
            const currentContentSection = [].find.call(contentSectionsWithToC, (contentSection) => _IsScrolledIntoView(contentSection)) || contentSectionsWithToC[contentSectionsWithToC.length - 1];
            if (currentContentSection) {
                const toCElementForCurrentSection = currentContentSection.previousElementSibling.querySelector('.table-of-contents');
                if (toCElementForCurrentSection.style.display === 'none') toCElementForCurrentSection.style.display = '';
                contentSectionsWithToC.forEach((contentSection) => {
                    const toCElementForSection = contentSection.previousElementSibling.querySelector('.table-of-contents');
                    if (toCElementForSection === toCElementForCurrentSection || toCElementForSection.style.display === 'none') return;
                    toCElementForSection.style.display = 'none';
                });
            }
        });
    });
}
function conditionallyRenderSeeMoreLessButtons() {
    const links = document.querySelector('.nav-links'); 
    if (!links || links.childElementCount > 4) {
        return;
    }

    document.querySelectorAll('.see-more-button, .see-less-button').forEach((button) => button.style.display = 'none');
}

function setupTableOfContents() {
    if (!document.querySelector('.table-of-contents') || document.querySelector('.table-of-contents.optTOC')) {
        return;
    }

    addHeadingsToTableOfContents();
    conditionallyRenderSeeMoreLessButtons();
    setupToggleClickHandlers();
    setupAnchorScrollBehavior();
    setupTableOfContentsJumpBehavior();
    if (window.innerWidth >= 992) {
        const tableOfContents = document.querySelectorAll('.table-of-contents');
        const navLinks = document.querySelectorAll('.table-of-contents .nav-links-wrapper');
        expandTableOfContents(navLinks, tableOfContents);
        window.addEventListener('resize', () => {
            if (window.innerWidth >= 992) {
                expandTableOfContents(navLinks, tableOfContents);
            } else {
                collapseTableOfContents(navLinks, tableOfContents);
            }
        });
    }
}

window.addEventListener('DOMContentLoaded', (event) => {
    setupTableOfContents();
});

